import React, { useRef } from 'react';
import './GallerySection.css';
import pikeinwater1 from '../assets/pikeinwater1.jpg';
import pikeinwater2 from '../assets/pikeinwater2.jpg';
import pooltest from '../assets/pooltest.jpg';
import cofounders from '../assets/cofounders.jpg';
import president from '../assets/president.jpeg';
import silina from '../assets/silina.jpeg';
import img1 from '../assets/1.jpeg';
import img2 from '../assets/2.jpeg';
import img03_1 from '../assets/2026-01-23 at 16.05.03(1).jpeg';
import img03_2 from '../assets/2026-01-23 at 16.05.03(2).jpeg';
import img03_3 from '../assets/2026-01-23 at 16.05.03(3).jpeg';
import img04 from '../assets/2026-01-23 at 16.05.04.jpeg';
import img04_1 from '../assets/2026-01-23 at 16.05.04(1).jpeg';
import img04_2 from '../assets/2026-01-23 at 16.05.04(2).jpeg';
import img05 from '../assets/2026-01-23 at 16.05.05.jpeg';
import img05_1 from '../assets/2026-01-23 at 16.05.05(1).jpeg';
import img06 from '../assets/2026-01-23 at 16.05.06.jpeg';
import img06_1 from '../assets/2026-01-23 at 16.05.06(1).jpeg';
import img07 from '../assets/2026-01-23 at 16.05.07.jpeg';

const GallerySection = () => {
  const scrollRef = useRef(null);

  const galleryItems = [
    { image: pikeinwater1, label: "PIKE Surfacing After Mission" },
    { image: pooltest, label: "Pool Tests" },
    { image: president, label: "Presidential Visit" },
    { image: pikeinwater2, label: "Deep Sea Testing" },
    { image: cofounders, label: "Founders in 2023" },
    { image: silina, label: "Latvian PM visit" },
    { image: img1, label: "Industry Visit" },
    { image: img2, label: "Presidential Visit" },
    { image: img03_2, label: "Presidential Visit" },
    { image: img03_3, label: "Pitch Event" },
    { image: img04, label: "Industry Visit" },
    { image: img04_1, label: "Presidential Visit" },
    { image: img04_2, label: "PM Visit at Industry Days" },
    { image: img05, label: "Government visit" },
    { image: img05_1, label: "Inspiring Students" },
    { image: img06, label: "UAE Visit" },
    { image: img06_1, label: "Government visit" },
    { image: img07, label: "Media Interview" },
    { image: img03_1, label: "Industry Networking" },
  ];

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = scrollRef.current.offsetWidth;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section className="gallery" id="gallery">
      <div className="container">
        {/* Section Header */}
        <div className="section-header">
          <span className="section-label">Gallery</span>
          <h2 className="section-title">
            Our Journey
            <span className="gradient-text"> So Far</span>
          </h2>
          <p className="section-subtitle">
            From pitch stages to presidential visits — building the future of underwater autonomy.
          </p>
        </div>

        {/* Scrollable Gallery */}
        <div className="gallery-scroll-wrapper">
          <button className="gallery-arrow gallery-arrow-left" onClick={() => scroll('left')} aria-label="Scroll left">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M15 18l-6-6 6-6"/>
            </svg>
          </button>

          <div className="gallery-scroll" ref={scrollRef}>
            {galleryItems.map((item, index) => (
              <div className="gallery-item" key={index}>
                <img src={item.image} alt={item.label} className="gallery-image" />
                <div className="gallery-overlay">
                  <span>{item.label}</span>
                </div>
              </div>
            ))}
          </div>

          <button className="gallery-arrow gallery-arrow-right" onClick={() => scroll('right')} aria-label="Scroll right">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 18l6-6-6-6"/>
            </svg>
          </button>
        </div>

        {/* Gallery CTA */}
        <div className="gallery-cta">
          <p>Want to see more of our work?</p>
          <a
            href="https://www.linkedin.com/company/submergebaltic/"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-secondary"
          >
            Follow Us on LinkedIn
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
